<template>
  <div class="box8">
    <pageTitle title="学生权益" />
    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'cur-nav': cur == index }"
          @click="changeCur(index)"
          ref="nav"
        >
          <p>{{ item.title }}</p>
        </div>
        
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="box">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
            <img :src="item.pic" alt="" />
          </div>
        </swiper-slide>
      </swiper>
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    let that = this;
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 100;
          }
        },
      },
      list:  [
        {
          title: "学生ID&学生邮箱",
          text: "学员入学后即可获得唯一的学生ID和带有院校后缀的学生邮箱。学员在正式入学后可以正式激活学生邮箱，并获得专属的账号与密码，用于登录院校内网https://my.iit.edu/。学生邮箱在学员毕业后能够继续使用。",
          pic: require("../../../assets/coursePage/illinois/box8/pic1.png"), 
        },
        {
          title: "专属的学生卡",
          text: "学员在正式入学2 - 3月后将收到专属的学生卡。学员可使用学生卡享受多数电子产品商家提供的教育优惠购买政策，包括苹果(Apple)、联想(Lenovo)、微软(Microsoft)等。",
          pic: require("../../../assets/coursePage/illinois/box8/pic2.png"), 
        },
        {
          title: "开具证明文件",
          text: "学员在读期间可以向校方申请开具在读证明、成绩单等文件。有过往在读学员通过展示自己的在读证明，助力其成功获得面试公司认可并拿到工作offer。",
          pic: require("../../../assets/coursePage/illinois/box8/pic3.png"), 
        },
        {
          title: "个人学籍信息查询",
          text: "无论是在读期间或是毕业后，学员均可以通过院校内网登录学生账号查询自己的学籍信息、学习记录、以及学位证书真实性。",
          pic: require("../../../assets/coursePage/illinois/box8/pic4.png"), 
        },
        {
          title: "学生专属的大量IT资源",
          text: "学员在读期间可以通过登录院校内网的虚拟桌面，获取学生账号专属的大量IT资源。大量的付费软件都可以使用学校的账号登录并在线使用，例如Office全家桶、AutoCAD、MATLAB、SQL Developer、Tableau、Visio、Visual Studio等",
          pic: require("../../../assets/coursePage/illinois/box8/pic5.png"), 
        },
        {
          title: "线上图书馆",
          text: "学员在读期间可以随时登录学校的线上图书馆，免费下载和查阅大量文献和书籍。",
          pic: require("../../../assets/coursePage/illinois/box8/pic6.png"), 
        },
        {
          title: "参加IIT校友会",
          text: "学员毕业后可加入IIT校友会，有机会与其他校友建立联系，推荐优秀校友，参与分享会等校友活动。",
          pic: require("../../../assets/coursePage/illinois/box8/pic7.png"), 
        },
        {
          title: "硕士学位证书",
          text: "学员毕业后可获得由院校颁发的硕士学位证书，书写样式、含金量与美国线下学员完全一致，证书全球认可。",
          pic: require("../../../assets/coursePage/illinois/box8/pic8.png"), 
        }
      ],
      cur: 0,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
      document.getElementsByClassName("nav-box")[0].scrollLeft = index * 100;
    },
  },
};
</script>

<style  lang="less" scoped>
.box8 {
  padding: 80px 0 0;
  background: #fff;
  width: 100%;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .subject-box {
   
    position: relative;
    margin: 48px auto 0;
    overflow: hidden;
    .nav-box::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }

    .nav-box {
      width: 100%;
      height: 72px;
      display: flex;
      justify-content: space-between;
      overflow: auto;
      .nav {
        height: 72px;
        background: #F4F4FB;
        p {
          padding: 0 24px;
          width: fit-content;
          white-space: nowrap;
          height: 62px;
          background: #fff;
          font-weight: 400;
          font-size: 30px;
          color: #272020;
          line-height: 42px;
          text-align: left;
        }
      }
      .cur-nav {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0; 
          right: 0;
          bottom: 0;
          margin: 0 auto;
          width: 138px;
          height: 14px;
          background: url('../../../assets/coursePage/illinois/box8/selected.png') no-repeat;
          background-size: cover;
        }
      }
    }
    .swiper-container{
      box-sizing: border-box;
      padding: 38px 0 80px;
      background: #F4F4FB;
    }
    .swiper-slide {
      position: relative;
      box-sizing: border-box;
      width: 622px;
      height: 796px;
      background: #FFFFFF;
      border-radius: 24px;
      .title {
        margin-top: 48px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 40px;
        color: #272020;
        line-height: 60px;
        text-align: center;
      }
      .text {
        margin-top: 16px;
        padding: 0 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 26px;
        color: #272020;
        line-height: 44px;
        text-align: center;
      }
      img {
        position: absolute;
        bottom: 40px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 558px;
        height: 380px;
        display: block;
      }
    }
  }
}
</style>
